import React, { useRef, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { LinearProgress } from '@material-ui/core';
import { LocalGasStation, LocalShipping, Delete } from '@material-ui/icons';
import { parseISO, format } from 'date-fns';
import { assign, isEmpty } from 'lodash';
import moment from 'moment';

import { Tabela, Modal, UnidataTable } from '~/components';
import { DialogConfirmation } from '~/componentsLocal';
import { LUBRIFICACAO, MODULO_20_GRAUS, TRR_CHILE } from '~/constants/modules';
import { t, canURL, number, can } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import { handleExportGeneric } from '~/helpers/exportReports';
import api from '~/services/api';
import {
  deleteOperacaoVazaoNaoAutorizada,
  findOperacaoVazaoNaoAutorizada,
  recordFiltering,
} from '~/store/modules/operacaovazaonaoautorizada/actions';

import Casting from './components/Casting';
import Supply from './components/Supply';
import Transfer from './components/Transfer';
import FormDeletar from './formDeletar';

import VazaoForm from './form';

function OperacaoVazaoNaoAutorizadaList() {
  const redux = useSelector((state) => state.operacaovazaonaoautorizada);

  const dispatch = useDispatch();
  const buttons = [];

  const [loading, setLoading] = useState(false);

  const supplyRef = useRef(null);
  const transfeRef = useRef(null);
  const deleteRef = useRef(null);
  const castingRef = useRef(null);

  const vazao = useSelector((state) => state.operacaovazaonaoautorizada);
  const {
    internounidatausuario,
    solicitacampolivremudamodoclienteconfig,
  } = useSelector((state) => state.user.configs);

  const chavemanual = [
    {
      label: 0,
      value: t(
        's.operacao.vazoanaoautorizada.chavemanualmovimentacao.desligada'
      ),
    },
    {
      label: 1,
      value: t('s.operacao.vazoanaoautorizada.chavemanualmovimentacao.ligada'),
    },
  ];

  const modoidentificadousuario = useMemo(
    () => [
      { label: '0', value: t('s.geral.opcoes.naoidentificado') },
      { label: '1', value: t('s.geral.opcoes.identificado') },
    ],
    []
  );

  async function handleUpdate(params = {}) {
    if (vazao) await dispatch(recordFiltering(assign(vazao.params, params)));
  }

  async function handleGETResponseMovement({ id, params, onCallback }) {
    try {
      setLoading(true);

      const { data } = await api.get(
        `movimentacoesvazoesnaoautorizadas/movimentacao/${id}`
      );

      if (isEmpty(data)) {
        onCallback();
        return;
      }

      castingRef.current.handleOpenModal({
        data: { ...data, ...params },
        onCallback,
      });
    } catch (err) {
      getToastErrors(err);
    } finally {
      setLoading(false);
    }
  }

  const initialDate = moment()
    .set({ hour: 0, minute: 0, second: 0 })
    .format('YYYY-MM-DD HH:mm:ss');

  const finalDate = moment()
    .set({ hour: 23, minute: 59, second: 59 })
    .format('YYYY-MM-DD HH:mm:ss');

  const header = useMemo(() => {
    const data = [
      // {
      //   id: 'datahorainicialmovimentacao',
      //   label: t('s.operacao.vazaonaoautorizada.datahorainicialmovimentacao'),
      //   format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      //   filter: {
      //     type: 'initialdatetime',
      //     defaultValue: initialDate,
      //   },
      // },
      // {
      //   id: 'datahorafinalmovimentacao',
      //   label: t('s.operacao.vazoanaoautorizada.datahorafinalmovimentacao'),
      //   format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      //   filter: {
      //     type: 'finaldatetime',
      //     defaultValue: finalDate,
      //   },
      // },
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 00:00:00'),
        },
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.operacao.vazoanaoautorizada.nomeposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idbico',
        label: t('s.operacao.vazoanaoautorizada.idbico'),
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.vazoanaoautorizada.nomeproduto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'chavemanualmovimentacao',
        label: t('s.geral.camposistema.chavemanualmovimentacao'),
        converter: chavemanual,
        filter: {
          type: 'select',
          options: chavemanual,
        },
      },
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.frentista'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'modoidentificadousuariostr',
        label: t('s.operacao.vazoanaoautorizada.modoidentificadousuariostr'),
        formatted: (value) =>
          modoidentificadousuario.find((s) => s.label === String(value))
            ?.value || '',
        filter: { type: 'select', options: modoidentificadousuario },
      },

      ...(solicitacampolivremudamodoclienteconfig === 'S'
        ? [
            {
              id: 'motivomovimentacao',
              label: t('s.geral.observacao'),
              filter: { type: 'text' },
            },
          ]
        : []),

      {
        id: 'volumemovimentacao',
        label: t('s.operacao.vazoanaoautorizada.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
    ];

    if (can(MODULO_20_GRAUS)) {
      data.splice(9, 0, {
        id: 'densidade20movimentacao',
        label: t('s.operacao.abastecimento.densidade20'),
        align: 'right',
        formatted: (value) => number(value, 4),
      });

      data.splice(9, 0, {
        id: 'temperaturamediamovimentacao',
        label: t('s.operacao.abastecimento.temperaturamedia'),
        align: 'right',
        formatted: (value) => number(value, 1),
      });

      data.splice(9, 0, {
        id: 'volume20movimentacao',
        label: t('s.operacao.abastecimento.volume20movimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      });
    }

    return data;
  }, [solicitacampolivremudamodoclienteconfig]);

  if (canURL().vazemabast) {
    buttons.push({
      disabled: loading,
      title: t(
        can(TRR_CHILE)
          ? 's.operacao.vazaonaoautorizada.transformarentregaproduto'
          : `s.operacao.vazaonaoautorizada.${
              can(LUBRIFICACAO)
                ? 'transformaabastlub'
                : 'transformarabastecimento'
            }`
      ),
      action: (value) =>
        handleGETResponseMovement({
          id: value.idmovimentacao,
          params: {
            idposto: value.idposto,
            idcliente: value.idcliente,
          },
          onCallback: () =>
            supplyRef.current.handleToggleModal({
              ...value,
              datahorainicialmovimentacao: format(
                parseISO(value.datahorainicialmovimentacao),
                'dd/MM/yyyy HH:mm'
              ),
              datahorafinalmovimentacao: format(
                parseISO(value.datahorafinalmovimentacao),
                'dd/MM/yyyy HH:mm'
              ),
            }),
        }),
      icon: <LocalGasStation />,
    });
  }

  if (canURL().vazemtransf) {
    buttons.push({
      title: t('s.operacao.vazaonaoautorizada.transformartransferencia'),
      disabled: loading,
      action: (value) =>
        handleGETResponseMovement({
          id: value.idmovimentacao,
          params: {
            idposto: value.idposto,
            idcliente: value.idcliente,
          },
          onCallback: () =>
            transfeRef.current.handleToggleModal({
              ...value,
              datahorainicialmovimentacao: format(
                parseISO(value.datahorainicialmovimentacao),
                'dd/MM/yyyy HH:mm'
              ),
              datahorafinalmovimentacao: format(
                parseISO(value.datahorafinalmovimentacao),
                'dd/MM/yyyy HH:mm'
              ),
            }),
        }),
      icon: <LocalShipping />,
    });
  }

  internounidatausuario?.toLowerCase() === 's' &&
    buttons.push({
      title: t('s.geral.botaoexcluir'),
      action: (value) => deleteRef.current.handleOpen(value),
      icon: <Delete />,
    });

  const fieldlist = [
    'datahorainicialmovimentacao',
    'datahorafinalmovimentacao',
    'codigonomeposto',
    'idbico',
    'nomeproduto',
    'chavemanualmovimentacao',
    'codigousuario',
    'modoidentificadousuariostr',
    ...(solicitacampolivremudamodoclienteconfig === 'S'
      ? ['motivomovimentacao']
      : []),
    'volumemovimentacao',
  ];

  const substituirHeader = {
    datahorainicialmovimentacao: t(
      's.operacao.abastecimento.datahorainicialmovimentacao'
    ),
    datahorafinalmovimentacao: t(
      's.operacao.abastecimento.datahorafinalmovimentacao'
    ),
    codigonomeposto: t('s.operacao.vazoanaoautorizada.nomeposto'),
    idbico: t('s.operacao.vazoanaoautorizada.idbico'),
    nomeproduto: t('s.operacao.vazoanaoautorizada.nomeproduto'),
    chavemanualmovimentacao: t('s.geral.camposistema.chavemanualmovimentacao'),
    volumemovimentacao: t('s.operacao.vazoanaoautorizada.volumemovimentacao'),
    codigousuario: t('s.cadastro.usuario.frentista'),
    modoidentificadousuariostr: t(
      's.operacao.vazoanaoautorizada.modoidentificadousuariostr'
    ),
    motivomovimentacao: t('s.geral.observacao'),
  };

  return (
    <>
      {loading && <LinearProgress />}

      <UnidataTable
        fixed
        actions={buttons}
        redux={vazao}
        header={header}
        read={recordFiltering}
        find={findOperacaoVazaoNaoAutorizada}
        delete={internounidatausuario.toLowerCase() !== 's'}
        remove={deleteOperacaoVazaoNaoAutorizada}
        form={VazaoForm}
        formAux={FormDeletar}
        keys={['idmovimentacao', 'idposto']}
        detach="nomeposto"
        pdf
        excel
        onExport={(formato) =>
          handleExportGeneric({
            endpoint: 'movimentacoesvazoesnaoautorizadas',
            formato,
            fields: fieldlist,
            headers: substituirHeader,
            redux,
            ordination: redux.params.ordination,
            orderfield: redux.params.orderfield,
            title: 'Relatorio de Vazão Não Autorizada',
          })
        }
      />

      <Supply ref={supplyRef} update={() => handleUpdate()} />

      <Transfer
        ref={transfeRef}
        update={(value) => handleUpdate(value)}
        filter={vazao.params}
      />

      <DialogConfirmation
        ref={deleteRef}
        keys={['idmovimentacao', 'idposto']}
        title="Justificativa para exclusão de registro"
        redux={deleteOperacaoVazaoNaoAutorizada}
        query={vazao.params}
      />

      <Modal
        ref={castingRef}
        form
        disableBackdropClick
        disableEscapeKeyDown
        onResetParams={false}
        onClose={() => handleUpdate()}
        maxWidth="sm"
        title={t('Confirmação de Transformação de Vazamento')}
        component={Casting}
      />
    </>
  );
}

export default OperacaoVazaoNaoAutorizadaList;
